import { createValidationErrorBoundaryOptions, ValidationErrorDisplayMode } from "@ngt-form/core";
import { useMemo } from "react";

import type { TMDValidationError } from "src/types/TMDValidationError";

/**
 * Memoizes validation-error display options for the supplied mode.
 *
 * Postconditions: Falsy modes return undefined; truthy modes delegate to the shared options
 * factory with no explicit boundary. The mode value alone invalidates the memo.
 */
const useTMDFormValidationErrorBoundaryOptions = <
    TFormValue extends object = object,
    TFormMetadata extends object = object,
    TFieldValue = unknown,
    TLookupItem = unknown
>(
    validationErrorDisplayMode?: ValidationErrorDisplayMode | null | undefined
) => {
    return useMemo(
        () => {
            if (!validationErrorDisplayMode) {
                return undefined;
            }

            return createValidationErrorBoundaryOptions<
                TFormValue,
                TMDValidationError,
                TFormMetadata,
                TFieldValue,
                TLookupItem
            >(undefined, validationErrorDisplayMode);
        },
        [validationErrorDisplayMode]
    );
};

export default useTMDFormValidationErrorBoundaryOptions;
